import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

const PermissionProtectedRoute = ({ children, requiredPermission, allowedRoles = [] }) => {
  const [loading, setLoading] = useState(true);
  const [hasPermission, setHasPermission] = useState(false);
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    checkPermission();
  }, []);

  const checkPermission = async () => {
    try {
      // Check authentication
      const token = localStorage.getItem('token');
      const userStr = localStorage.getItem('user');
      
      if (!token || !userStr) {
        setLoading(false);
        return;
      }

      const user = JSON.parse(userStr);
      setUserRole(user.role);

      // Client role is never allowed for permission-protected routes
      if (user.role === 'client') {
        setHasPermission(false);
        setLoading(false);
        return;
      }

      // Check if role is allowed
      if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
        setHasPermission(false);
        setLoading(false);
        return;
      }

      // If no specific permission required, just check role
      if (!requiredPermission) {
        setHasPermission(true);
        setLoading(false);
        return;
      }

      // Check permission via API
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const response = await axios.get(
        `${API_URL}/api/rbac/check-permission/${requiredPermission}`,
        config
      );

      setHasPermission(response.data.has_permission);
      setLoading(false);
    } catch (error) {
      console.error('Error checking permission:', error);
      setHasPermission(false);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">جاري التحقق من الصلاحيات...</p>
        </div>
      </div>
    );
  }

  // Not authenticated
  if (!userRole) {
    return <Navigate to="/login" />;
  }

  // Client trying to access
  if (userRole === 'client') {
    return <Navigate to="/client/dashboard" />;
  }

  // No permission
  if (!hasPermission) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center" dir="rtl">
        <div className="text-center max-w-md p-8 bg-white rounded-lg shadow-lg">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">الوصول مرفوض</h2>
          <p className="text-gray-600 mb-6">
            ليس لديك صلاحية للوصول إلى هذه الصفحة. يرجى التواصل مع المسؤول لمنحك الصلاحيات اللازمة.
          </p>
          <button
            onClick={() => window.history.back()}
            className="px-6 py-2 bg-amber-600 text-white rounded-lg hover:bg-amber-700"
          >
            العودة
          </button>
        </div>
      </div>
    );
  }

  return children;
};

export default PermissionProtectedRoute;
